import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift, Sparkles } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-brand-500" data-id="element-92" data-mp="28cvgw0iwb96v" />,
    color: 'bg-brand-50 border-brand-100',
    label: 'TOMO 1',
    title: 'EL MAPA DE TU ESTRÉS',
    desc: 'Aprendé a identificar qué situaciones, pensamientos y hábitos mantienen a tu cuerpo en estado de alerta. Reconocé tus señales físicas y descubrí cómo responde tu sistema nervioso frente al estrés.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-lav-500" data-id="element-93" data-mp="2r0qo11k05or0" />,
    color: 'bg-lav-50 border-lav-100',
    label: 'TOMO 2',
    title: 'MANUAL DEL NERVIO VAGO',
    desc: 'Conocé el papel del nervio vago y aplicá ejercicios simples de respiración, orientación y estimulación corporal para favorecer una respuesta de mayor calma y seguridad.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-brand-400" data-id="element-94" data-mp="1vk5njys2abci" />,
    color: 'bg-brand-50 border-brand-100',
    label: 'TOMO 3',
    title: 'MAÑANAS EN CALMA',
    desc: 'Creá una rutina matinal sencilla para evitar comenzar el día con ansiedad, tensión o pensamientos acelerados. Incluye hábitos breves para despertar con mayor estabilidad.'
  }, {
    icon: <Library className="w-8 h-8 text-lav-600" data-id="element-95" data-mp="29lhy1uogdkr0" />,
    color: 'bg-lav-50 border-lav-100',
    label: 'TOMO 4',
    title: 'MÉTODO SUEÑO REPARADOR',
    desc: 'Organizá una rutina nocturna para ayudar a reducir la activación antes de dormir, disminuir las vueltas mentales y preparar al cuerpo para un descanso más profundo.'
  }, {
    icon: <Notebook className="w-8 h-8 text-brand-500" data-id="element-96" data-mp="2t8fpkdrukz3m" />,
    color: 'bg-brand-50 border-brand-100',
    label: 'TOMO 5',
    title: 'NUTRICIÓN PARA LOS NERVIOS',
    desc: 'Descubrí alimentos, combinaciones y hábitos cotidianos que pueden acompañar el bienestar general, la energía estable y una rutina más amigable con tu sistema nervioso.'
  }, {
    icon: <BookType className="w-8 h-8 text-lav-500" data-id="element-97" data-mp="124095tbalc45" />,
    color: 'bg-lav-50 border-lav-100',
    label: 'TOMO 6',
    title: 'PLAN DE 30 DÍAS DE RESET',
    desc: 'Seguí un recorrido guiado de 30 días que organiza las herramientas del Megapack para incorporarlas progresivamente y construir una rutina de regulación sostenible.'
  }];
  return <section className="py-12 px-4 bg-lav-50 pt-[4px] pb-[4px]" data-id="element-98" data-mp="1ltakyw7x3cwz">
      <div className="max-w-5xl mx-auto" data-id="element-99" data-mp="1gvive8uqw2vy">
        <div className="text-center mb-10" data-id="element-100" data-mp="1guhbrfzny82m">
          <Badge variant="success" className="mb-4" data-id="element-101" data-mp="1uv1qo12gjjqu">
            PUNTO DIGITAL™ — MEGAPACK REGULACIÓN DEL SISTEMA NERVIOSO
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4" data-id="element-102" data-mp="1px0bhr85k4kn">
            NO TE FALTA FUERZA DE VOLUNTAD. TU SISTEMA NERVIOSO NECESITA
            APRENDER A VOLVER A LA CALMA.
          </h2>
          <p className="text-lg text-slate-400" data-id="element-103" data-mp="3rolrc2mon7p9">
            Este Megapack te brinda una hoja de ruta clara para comprender tus
            señales de estrés y aplicar recursos prácticos que ayuden a tu
            cuerpo a recuperar seguridad, descanso y equilibrio en el día a día.
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-600" data-id="element-104" data-mp="1ybwgt93dugo3">
            <span data-id="element-105" data-mp="22d8bht145s35">Estrés</span> <span className="text-slate-600" data-id="element-106" data-mp="22cq9efrrsjnb">→</span>
            <span data-id="element-107" data-mp="1oe8lagxyd54v">Nervio vago</span> <span className="text-slate-600" data-id="element-108" data-mp="1oe0bwz11ghyf">→</span>
            <span data-id="element-109" data-mp="1tduy4p9vcjd5">Mañanas</span> <span className="text-slate-600" data-id="element-110" data-mp="1teealqgr2fjs">→</span>
            <span data-id="element-111" data-mp="1tbrzxhykbjxc">Descanso</span> <span className="text-slate-600" data-id="element-112" data-mp="1fe3hshvvqqvz">→</span>
            <span data-id="element-113" data-mp="1ffes70jtyww2">Nutrición</span> <span className="text-slate-600" data-id="element-114" data-mp="1fg6grrf0fucu">→</span>
            <span data-id="element-115" data-mp="1jex63cd8i7pe">30 días</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-116" data-mp="1jhi5zvtz2dki">
          <h3 className="text-xl font-bold text-ink mb-5 flex items-center gap-3" data-id="element-117" data-mp="39ruxnz4sy6zv">
            <Sparkles className="w-8 h-8 text-brand-500" data-id="element-118" data-mp="3dtg698aazz49" /> 6 TOMOS COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-119" data-mp="2p327bt10c9ru">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-120" data-mp="2k3z9asjg33td" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-121" data-mp="2k4qud9ff1j5e">
                  <div className="p-3 bg-white rounded-xl shrink-0 border border-lav-100" data-id="element-122" data-mp="2f435ouenteec">
                    {tomo.icon}
                  </div>
                  <div data-id="element-123" data-mp="2a5jf2gp4fefn">
                    <p className="text-slate-500 text-[11px] font-semibold tracking-widest uppercase mb-1" data-id="element-124" data-mp="2647qmehzgz91">
                      {tomo.label}
                    </p>
                    <h4 className="font-bold text-ink text-xl mb-3 leading-tight" data-id="element-125" data-mp="21c6gay4dliln">
                      {tomo.title}
                    </h4>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-126" data-mp="1rfjy6h3fp5nb">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-white" data-id="element-127" data-mp="1ifwt9lbhxhpi">
          <h4 className="font-bold text-xl text-ink mb-6" data-id="element-128" data-mp="1igzlbwkk1q70">Cada tomo incluye:</h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-129" data-mp="3u1pbn79q1muy">
            {['Paso a paso.', 'Ejercicios guiados.', 'Rutinas breves.', 'Aplicación inmediata.', 'Consejos prácticos.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-130" data-mp="bv1317fgqhkj" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-brand-500 shrink-0 mt-0.5" data-id="element-131" data-mp="3aehsyx9jpvb2" />
                <span className="text-slate-300" data-id="element-132" data-mp="3fd2leaik3aoy">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'SOS EN LA OFICINA',
    desc: 'Técnicas discretas y breves para calmar la activación durante el trabajo sin llamar la atención. Incluye respiración cuadrada, anclaje de pies y técnica 5-4-3-2-1.',
    value: '$8.000'
  }, {
    title: 'CASA LIBRE DE ESTRÉS',
    desc: 'Checklist de ajustes simples en iluminación, ruido, orden y espacios para transformar tu hogar en un entorno que favorezca el descanso y la sensación de seguridad.',
    value: '$8.000'
  }, {
    title: 'DIARIO SOMÁTICO',
    desc: 'Plantilla de seguimiento diario para registrar qué disparó el estrés, qué síntomas físicos aparecieron y qué herramienta te ayudó a recuperar la calma.',
    value: '$9.000'
  }, {
    title: 'RECETARIO DE CALMA',
    desc: 'Ideas simples de infusiones, menús y preparaciones cotidianas para acompañar una rutina de bienestar, descanso y alimentación más equilibrada.',
    value: '$8.000'
  }, {
    title: 'LÍMITES Y RESPUESTAS',
    desc: 'Guía con frases prácticas para decir que no, reducir compromisos excesivos y poner límites frente a situaciones o personas que te dejan agotado.',
    value: '$9.000'
  }];
  return <section className="py-12 px-4" data-id="element-133" data-mp="3m1sov82h284j">
      <div className="max-w-5xl mx-auto" data-id="element-134" data-mp="3m0rcn09pzfl8">
        <div className="text-center mb-8" data-id="element-135" data-mp="17ti2h3wf891o">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-3 flex items-center justify-center gap-3" data-id="element-136" data-mp="17sqh0lwjfrp4">
            <Gift className="w-9 h-9 text-brand-500" data-id="element-137" data-mp="1cu61ocuszw6z" />5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-600 font-bold uppercase tracking-widest" data-id="element-138" data-mp="yu516yigaqs1">
            Todo lo que necesitás para aplicar las herramientas desde el primer
            día.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-4 mb-8" data-id="element-139" data-mp="1ri0vjwkjs6ln">
          {bonuses.map((bono, i) => <Card key={i} className={`relative overflow-hidden group hover:border-brand-300 transition-colors lg:col-span-2 ${i === 3 ? 'lg:col-start-2' : ''}`} data-id="element-140" data-mp="1vib51j7jtf59" data-mpi={i}>
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-141" data-mp="1moo7bnjs61tf">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-ink text-lg mb-3 pr-12 mt-2" data-id="element-142" data-mp="2f7v78at4rp4b">
                {bono.title}
              </h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-143" data-mp="f657dhplt6ou">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-lav-100 flex justify-between items-center" data-id="element-144" data-mp="adbz4juxfg80">
                <span className="line-through text-slate-500 text-sm" data-id="element-145" data-mp="5fsn7qlpbfj8">
                  Valor {bono.value}
                </span>
                <span className="text-brand-600 font-bold" data-id="element-146" data-mp="duyiguj7siw">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-brand-50 border border-brand-200 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-147" data-mp="t43ime8mon04">
          <p className="text-slate-300 mb-2" data-id="element-148" data-mp="o4qttny755uw">Valor total bonos</p>
          <p className="text-4xl font-black text-ink mb-2 line-through decoration-brand-400/60" data-id="element-149" data-mp="k3x7v04be14n">
            $42.000
          </p>
          <p className="text-2xl font-bold text-brand-600" data-id="element-150" data-mp="38vzpptsdr6qf">
            → +5 BONOS GRATIS con tu Megapack
          </p>
        </div>
      </div>
    </section>;
}